import { useMutation } from "@tanstack/react-query";

import { rateTicket } from "../services/reviews";

export function useRateTicket() {
  return useMutation({
    mutationFn: ({ ticketId, rating }: { ticketId: string; rating: number }) =>
      rateTicket(ticketId, rating),
  });
}
